import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import '../styles/legal-pages.css';

function CookieTable({ headers, rows }) {
	return (
		<table className="legal-table">
			<thead>
				<tr>
					{headers.map((h, i) => <th key={i}>{h}</th>)}
				</tr>
			</thead>
			<tbody>
				{rows.map((row, i) => (
					<tr key={i}>
						{row.map((cell, j) => <td key={j}>{cell}</td>)}
					</tr>
				))}
			</tbody>
		</table>
	);
}

export default function CookiePolicy() {
	const { t } = useTranslation();
	const tableHeaders = t('cookiePolicy.tableHeaders', { returnObjects: true });
	const necessaryRows = t('cookiePolicy.necessaryRows', { returnObjects: true });
	const analyticsRows = t('cookiePolicy.analyticsRows', { returnObjects: true });
	const marketingRows = t('cookiePolicy.marketingRows', { returnObjects: true });
	const section4Steps = t('cookiePolicy.section4Steps', { returnObjects: true });

	return (
		<div className="legal-page">
			<Helmet>
				<title>{t('cookiePolicy.pageTitle')}</title>
				<meta name="description" content={t('cookiePolicy.metaDescription')} />
				<meta name="robots" content="noindex, follow" />
			</Helmet>

			<div className="legal-container">
				<h1>{t('cookiePolicy.title')}</h1>
				<p className="legal-subtitle">{t('cookiePolicy.subtitle')}</p>
				<p className="legal-updated">{t('cookiePolicy.lastUpdated')}</p>

				<section>
					<h2>{t('cookiePolicy.section1Title')}</h2>
					<p>{t('cookiePolicy.section1Text')}</p>
				</section>

				<section>
					<h2>{t('cookiePolicy.section2Title')}</h2>

					<h3>{t('cookiePolicy.necessaryTitle')}</h3>
					<p>{t('cookiePolicy.necessaryText')}</p>
					<CookieTable headers={tableHeaders} rows={necessaryRows} />

					<h3>{t('cookiePolicy.analyticsTitle')}</h3>
					<p>{t('cookiePolicy.analyticsText')}</p>
					<CookieTable headers={tableHeaders} rows={analyticsRows} />

					<h3>{t('cookiePolicy.marketingTitle')}</h3>
					<p>{t('cookiePolicy.marketingText')}</p>
					<CookieTable headers={tableHeaders} rows={marketingRows} />
				</section>

				<section>
					<h2>{t('cookiePolicy.section3Title')}</h2>

					<h3>{t('cookiePolicy.section3_1Title')}</h3>
					<p>{t('cookiePolicy.section3_1Text')}</p>

					<h3>{t('cookiePolicy.section3_2Title')}</h3>
					<p>{t('cookiePolicy.section3_2Text')}</p>
					<ul>
						<li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
						<li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
						<li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a></li>
						<li><a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
					</ul>
					<p><strong>{t('cookiePolicy.section3_2Note')}</strong></p>
				</section>

				<section>
					<h2>{t('cookiePolicy.section4Title')}</h2>
					<p>{t('cookiePolicy.section4Text')}</p>
					<ol>
						{section4Steps.map((step, i) => <li key={i}>{step}</li>)}
					</ol>
					<p>{t('cookiePolicy.section4Alt')}</p>
				</section>

				<section>
					<h2>{t('cookiePolicy.section5Title')}</h2>
					<p>
						<strong>Ing. Eleonora Bernasconi - Studio di Ingegneria dell'Informazione</strong><br />
						Via del Sudario 35, 00186 Roma (RM)<br />
						Email: <a href="mailto:info@ingegneriabernasconi.it">info@ingegneriabernasconi.it</a>
					</p>
					<p>
						{t('cookiePolicy.section5Text')}{' '}
						<a href="/privacy-policy">Privacy Policy</a>.
					</p>
				</section>

				<div className="legal-back">
					<a href="/">{t('cookiePolicy.backHome')}</a>
				</div>
			</div>
		</div>
	);
}
